/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2LocationPin/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2LocationPin({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2LocationPin",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 12,
  height = 12,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2LocationPin.Svg"
  data-view-path={viewPath}
 viewBox="0 0 12 12"
 style={{'--as-1-1MdtNK': alignSelf,'--mt-2-1MdtNK': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1MdtNK': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1MdtNK': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1MdtNK': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1MdtNK': opacity,'--w-10-1MdtNK': typeof width === 'number' ? `${width}px` : width,'--h-11-1MdtNK': typeof height === 'number' ? `${height}px` : height,'--f-12-1MdtNK': fill,'--a-7-1MdtNK': isAnimated ? animation : "none",'--sd-8-1MdtNK': isAnimated ? strokeDashoffset : 0,'--sd-9-1MdtNK': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2LocationPin.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M5.991 0c2.247 0 4.12 1.872 4.12 4.12 0 .732-.253 1.456-.605 2.11-.354.659-.822 1.273-1.287 1.796a13.39 13.39 0 01-1.304 1.276 7.818 7.818 0 01-.467.371 2.478 2.478 0 01-.167.112.907.907 0 01-.15.071.462.462 0 01-.346-.026.898.898 0 01-.085-.046 2.487 2.487 0 01-.167-.113 7.84 7.84 0 01-.467-.373 13.58 13.58 0 01-1.303-1.283c-.465-.524-.933-1.139-1.286-1.795-.352-.653-.605-1.373-.605-2.1C1.872 1.871 3.744 0 5.992 0zm0 5.35a1.23 1.23 0 110-2.461 1.23 1.23 0 010 2.46zm2.656 3.355c.158-.178.317-.364.472-.557h1.151c.171 0 .326.102.394.26l1.284 2.995a.429.429 0 01-.394.597H.429a.428.428 0 01-.394-.597l1.283-2.996a.429.429 0 01.394-.26h1.162c.152.19.306.372.46.546.567.64 1.14 1.18 1.586 1.56.223.191.418.345.566.453.074.054.142.1.199.134a1 1 0 00.162.079.468.468 0 00.355-.027c.034-.015.066-.034.094-.05.057-.035.125-.08.199-.134.148-.107.343-.26.566-.449.446-.38 1.02-.916 1.586-1.554z"
 style={{'--f-12-1MdtNK': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}